import { ColorVariantsList } from './ColorVariantsList/ColorVariantsList';
import { ColorVariantsSlider } from './ColorVariantsSlider/ColorVariantsSlider';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import { ColorVariantType } from 'types/product';

type Props = {
    colorVariants: ColorVariantType[];
    currentVariantUuid: string;
};

export const ColorVariants: FC<Props> = ({ colorVariants, currentVariantUuid }) => {
    const t = useTypedTranslationFunction();

    const isDesktop = useMediaMin('vl');

    return (
        <>
            <div className="mb-1 text-body font-bold leading-6">{t('Choose color variant')}</div>
            {isDesktop ? (
                <ColorVariantsList currentVariantUuid={currentVariantUuid} colorVariants={colorVariants} />
            ) : (
                <ColorVariantsSlider currentVariantUuid={currentVariantUuid} colorVariants={colorVariants} />
            )}
        </>
    );
};
